"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chunkArray = exports.checkForDom = exports.pxToRem = void 0;

// converts a pixel value to rem value
var pxToRem = function pxToRem(px) {
  return "".concat(px / 16, "rem");
}; // check the DOM is present for `loadCSS` to load append the fontawesome css


exports.pxToRem = pxToRem;

var checkForDom = function checkForDom() {
  var refs = (document.body || document.getElementsByTagName('head')[0]).childNodes;
  var ref = refs[refs.length - 1];
  return ref && ref.parentNode;
}; // split an array in chunks of defined size


exports.checkForDom = checkForDom;

var chunkArray = function chunkArray(bigArray, chunkSize) {
  var clonedBigArray = bigArray.slice();
  var results = [];

  while (clonedBigArray.length) {
    results.push(clonedBigArray.splice(0, chunkSize));
  }

  return results;
};

exports.chunkArray = chunkArray;